/** tempexp_14728-full-file */
import classNames from 'clsx';
import React, { memo } from 'react';
import { formatDefaultDate, formatExpiresDropdown } from 'reactApp/utils/formatDate';

import styles from './Expires.css';

interface ExpiresProps {
    className?: string;
    expires?: number;
    isAutoDelete?: boolean;
    isShared?: boolean;
}

export const Expires = memo<ExpiresProps>(function Expires({ className, expires, isAutoDelete, isShared }) {
    return (
        <div
            className={classNames(styles.root, className, {
                [styles.autodelete]: isAutoDelete,
            })}
        >
            {!!expires &&
                (isAutoDelete
                    ? `Удалится ${formatDefaultDate(expires)}`
                    : isShared && `Доступ открыт до ${formatExpiresDropdown(expires, true)}`)}
        </div>
    );
});
